<template>
<span class="surveillance-export-modal">
  <h2>Jeux de données «{{dataset}}»</h2>
  <alert type="info">
    <p>
      Les dénominateurs sont téléchargées au <strong>format CSV</strong>.
    </p>
  </alert>
  <btn size="lg"
       type="info"
       @click="exportDenominators()">
    Dénominateurs
  </btn>
  <save-blob :target="csv.target"></save-blob>
  <modal v-model="show"
         size="lg"
         :backdrop="false"
         :keyboard="false"
         :footer="false"
         :header="false">
    <div class="export-modal">
      <div class="row">
        <div class="col-xs-12">
          <steps :steps="iterator.steps" :stepStates="iterator.stepStates"></steps>
        </div>
      </div>
      <div v-if="completed">
        <btn @click="hide" type="default">Retour</btn>
      </div>
    </div>
  </modal>
</span>
</template>

<script>
import stringify from 'csv-stringify'
import StepIterator from '@/sui/tools/stepiterator'
import stepsViewer from '@/sui/components/steps'
import saveBlob from '@/sui/components/saveblob'
import flatten from '@/sui/data/flatten/datasets'

import moment from 'moment'

export default {
  name: 'infections-export',

  props: {
    year: {
      type: String,
      required: true
    },

    dataset: {
      type: String,
      required: true
    }
  },

  data: function () {
    const steps = [
      {
        title: 'Récupération des datasets',
        error: null,
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.error = null
            const instance = this
            var request = { name: vm.dataset, step: 0 }
            vm.$store.dispatch('dataset/all', request).then(
              (response) => {
                if (response.data.err == null) {
                  data.full = response.data.v
                } else {
                  instance.error = response.data.err
                }
              }
            ).catch(e => { instance.error = e })
          }
          return {
            end: data.full != null || this.error != null,
            success: this.error == null
          }
        },
        setError: function (e) {
          return `Erreur lors de la récupération des datasets : ${e}.`
        }
      },

      {
        title: 'Récupération des inscriptions',
        error: null,
        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.error = null
            const instance = this
            vm.$store.dispatch('surveillances/all', vm.year).then(
              (response) => {
                if (response.data.err == null) {
                  data.survs = Object.freeze(response.data.v)
                } else {
                  instance.error = response.data.err
                }
              }
            ).catch(e => { instance.error = e })
          }
          return {
            end: data.survs != null || this.error != null,
            success: this.error == null
          }
        },
        setError: function (e) {
          return `Erreur lors de la récupération des inscriptions : ${e}.`
        }
      },

      {
        title: 'Mise à plat des dénominateurs',
        index: 0,

        run: function (vm, data, iteration) {
          if (iteration === 0) {
            this.index = 0
            data.out = []
          }
          const max = data.full.length
          const step = 100
          const end = this.index + step >= max ? max : this.index + step
          for (let i = this.index; i !== end; ++i) {
            const s = data.full[i]
            if (s.den == null) {
              continue
            }

            const estb = data.survs.find(
              e => e.id === s.surv
            )
            if (estb == null) {
              continue
            }
            const ds = flatten.createExportedDatasets(vm.year, s, estb.establishment)
            for (let j = 0; j < ds.length; j++) {
              data.out.push(ds[j])
            }
          }
          this.index = end

          return {
            end: this.index === max,
            success: true
          }
        },

        setError: function (e) {
          return `Erreur lors de la mise à plat des dénominateurs: ${e}.`
        }
      },

      {
        title: 'Export du fichier',
        end: false,
        success: false,

        run: function (vm, data, iteration) {
          const instance = this
          if (iteration === 0) {
            this.end = false
            this.success = false
            this.output = null
            const sorted = data.out.sort(function (a, b) {
              return a.etab > b.etab
            })
            stringify(
              sorted,
              {
                header: true,
                bom: true,
                delimiter: ';'
              },
              function (err, output) {
                if (err != null) {
                  instance.end = true
                  instance.success = false
                  instance.errorDetail = err
                  instance.setError()
                } else {
                  instance.end = true
                  instance.success = true
                  instance.output = output
                }
              }
            )
          }

          if (this.end && this.success) {
            setTimeout(
              function () {
                const date = moment().format('DD-MM-YYYY-HH-mm-ss')
                vm.csv.target = {
                  filename: `${vm.dataset} - DATASETS - ${date}.csv`,
                  blob: new Blob([instance.output], { type: 'text/plain' })
                }
              }, 10)
          }
          return {
            end: this.end,
            success: this.success,
            error: this.error
          }
        },
        setError: function (e) {
          return `Erreur lors de la création du fichier d'export: ${e}`
        }
      }
    ]
    return {
      infection: '',
      show: false,
      csv: {
        target: null
      },
      iterator: new StepIterator(steps)
    }
  },

  computed: {
    completed: function () {
      return this.iterator.completed
    }
  },

  watch: {
    show: function (value) {
      if (!value) {
        this.iterator.reset()
      }
    }
  },

  methods: {
    exportDenominators: function (infct) {
      this.iterator.start(this)
      this.show = true
    },

    hide: function () {
      this.show = false
    }
  },

  components: {
    'save-blob': saveBlob,
    'steps': stepsViewer
  }

}
</script>
